import React, {PureComponent} from "react"
import styled from "styled-components"

import {H4} from "@irati/ui/src//Typography/Heading"
import {Para} from "@irati/ui/src/Labels"
import FormattedMessage from "@irati/utils/lang"

const InlineBlock = styled.div`
  display: inline-block;
`

const InlineH4 = styled(H4)`
  display: inline;
`

const GreyInlinePara = styled(Para)`
  display: inline;
`

interface Props {
  number: number,
  text: string
}

class NumberAndText extends PureComponent<Props> {
  render() {
    const {number, text} = this.props
    return (
      <InlineBlock>
        <InlineH4>{number}</InlineH4> <GreyInlinePara large light><FormattedMessage id={text} /></GreyInlinePara>
      </InlineBlock>
    )
  }
}

export default NumberAndText
